const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Mybank24 = function Mybank24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M25.5994 10.2396C24.1845 10.2273 23.523 11.0466 23.523 11.0466C23.0942 11.5086 23.3698 12.1246 23.7925 12.1739C24.3989 12.2417 24.3927 11.7304 25.3238 11.5025C26.1384 11.3053 26.1752 12.063 26.1752 12.063C22.6961 11.9768 22.8615 14.9152 24.0436 15.5374C25.1768 16.1349 26.2425 15.3834 26.2425 15.3834C26.2425 15.3834 26.2793 15.7899 26.8428 15.7899C27.4859 15.7899 27.4859 15.1431 27.4859 15.1431V12.2848C27.4369 10.1904 25.5994 10.2396 25.5994 10.2396ZM25.3238 14.3793C25.3238 14.3793 24.4111 14.5641 24.4234 13.9111C24.4295 13.2581 26.0833 13.2951 26.2487 13.3505C26.2487 13.3444 26.3038 14.0897 25.3238 14.3793Z",
      fill: "#204866",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M36.8393 14.6315L35.4182 12.4816L36.4595 11.4898C36.4595 11.4898 36.9434 11.0402 36.5452 10.5966C36.1104 10.1038 35.5836 10.5905 35.5836 10.5905L34.2728 11.8163V9.35843C34.2728 9.0073 33.9911 8.71777 33.6358 8.71777C33.2867 8.71777 32.9988 9.00114 32.9988 9.35843V15.1428C32.9988 15.4939 33.2805 15.7835 33.6358 15.7835C33.9849 15.7835 34.2728 15.5001 34.2728 15.1428V13.6028L34.5117 13.3625L35.798 15.3892C35.798 15.3892 36.2145 16.0915 36.8331 15.6418C37.2986 15.303 36.8393 14.6315 36.8393 14.6315Z",
      fill: "#204866",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M32.3128 12.2783C32.3128 10.19 30.5794 9.89433 29.4034 10.5596V10.5658C29.3176 10.3132 29.0787 10.1284 28.797 10.1284C28.4417 10.1284 28.1477 10.4179 28.1477 10.7814V15.1366C28.1477 15.4939 28.4356 15.7896 28.797 15.7896C29.1522 15.7896 29.4462 15.5001 29.4462 15.1366L29.4401 12.1982C29.4401 12.1982 29.5994 12.0134 29.8505 11.8286C30.4569 11.3974 31.0327 11.5453 31.0327 12.2845L31.051 15.1489C31.051 15.5062 31.3389 15.7896 31.688 15.7896C32.0372 15.7896 32.3251 15.5001 32.3251 15.1489L32.3128 12.2783Z",
      fill: "#204866",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M13.6738 15.8696C13.8208 15.6232 13.8453 15.4446 13.8453 15.4446L12.3814 11.5945C12.3814 11.5945 12.118 10.8491 12.6999 10.6273C13.3185 10.3933 13.5452 10.9908 13.588 11.114C13.637 11.2372 14.5129 13.5904 14.5129 13.5904L15.3582 11.1202C15.3582 11.1202 15.6032 10.3501 16.277 10.6273C16.8344 10.8553 16.5465 11.6068 16.5465 11.6068C16.5465 11.6068 15.6828 14.1818 14.954 16.0483C14.5191 17.1633 14.1516 17.2741 13.7289 17.3789C13.1654 17.5206 12.0935 17.4466 12.0935 16.7444C12.0935 16.1838 12.6631 16.153 12.9204 16.1592C12.9449 16.1592 13.4717 16.2084 13.6738 15.8696Z",
      fill: "#27BCED",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M10.2744 9.40174L8.93912 13.1163L7.48133 9.42022C7.48133 9.42022 7.26695 8.72412 6.65443 8.72412C5.95004 8.72412 5.97454 9.2847 5.95616 9.42022C5.93779 9.55574 5.95616 15.1923 5.95616 15.1923C5.95616 15.1923 5.95004 15.7837 6.59318 15.7837C7.2547 15.7837 7.22407 15.1861 7.2302 15.1861C7.23632 15.1861 7.2302 12.2108 7.2302 12.2108L8.3021 15.1861C8.3021 15.1861 8.46135 15.7713 8.95749 15.759C9.45363 15.7467 9.59451 15.1861 9.59451 15.1861L10.4949 12.2169V15.1861C10.4949 15.1861 10.4949 15.7837 11.1442 15.7837C11.7751 15.7837 11.7751 15.1861 11.7751 15.1861V9.42638C11.7751 9.42638 11.7751 8.72412 11.089 8.72412C10.5255 8.73028 10.3111 9.27854 10.2744 9.40174C10.2683 9.41406 10.2683 9.42638 10.2683 9.42638L10.2744 9.40174Z",
      fill: "#27BCED",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M37.0476 18.0567H25.7528H17.4593L17.4655 18.0629C15.8239 19.991 13.3922 21.223 10.6665 21.223C5.72966 21.223 1.72994 17.2004 1.72994 12.2354C1.72994 7.27027 5.72966 3.24769 10.6665 3.24769C13.3984 3.24769 15.8484 4.48588 17.4838 6.42632H19.2785C17.4165 3.63577 14.2559 1.80005 10.6665 1.80005C4.93339 1.80005 0.290527 6.47561 0.290527 12.2354C0.290527 17.9951 4.93339 22.6707 10.6665 22.6707C13.674 22.6707 16.3752 21.377 18.2679 19.3257L36.1901 19.3072L37.0476 18.0567Z",
      fill: "#27BCED",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M22.0226 12.0012C22.0594 11.9519 22.4881 11.6008 22.4514 10.6644C22.384 8.77327 20.7486 8.79175 20.3872 8.78559C19.8053 8.76711 19.4562 8.77327 18.3843 8.78559C17.4777 8.79175 17.49 9.61721 17.49 9.61721V15.7835H20.5342C22.1635 15.7835 22.7699 14.8841 22.7699 13.6213C22.7699 12.3523 22.0226 12.0012 22.0226 12.0012ZM18.8008 10.0915H20.4852C20.8221 10.0977 21.1773 10.2825 21.1773 10.7876C21.1773 11.3174 20.8711 11.4837 20.4852 11.4837H18.8008V10.0915ZM20.6016 14.5269H18.8008V12.7959H20.6016C21.0365 12.8205 21.4591 13.0423 21.4591 13.6583C21.4591 14.2928 21.0732 14.5269 20.6016 14.5269Z",
      fill: "#204866",
    })
  );
};
Mybank24.defaultProps = {
  width: "38",
  height: "24",
  viewBox: "0 0 38 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Mybank24,
};
export function Mybank(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Mybank' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
